module.exports = __webpack_public_path__ + "img/rule_2021.df3e925e.png";